export default [
  '#2193C3',
  '#00AEEF',
  '#2193C3',
  '#FAB040',
  '#D2232A',
  '#6F7073',
  '#7ABF49',
  '#D94848',
  '#ff0000',
  '#0000ff',
  '#FFDB4D',
  '#4DB84D',
];
